<div class="world_clock">
  <div class="world_clock__table">
    <dr-ops-stream-ui-world-clock-table [rows]="rows()" />
  </div>
</div>
